import React, { useEffect, useState } from "react";
import { Checkbox, Select } from "../../form/inputs";
import { Home, Plus } from "lucide-react";
import { GoMoon, GoSun } from "react-icons/go";
import InputBase from "../../form/inputs/InputBase";
import WeeklyPlan from "../../Cards/Weeklyplan";
import Montlyplan from "../../Cards/Monthlyplan";
import { useLocation, useNavigate } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import SecondaryBtn from "../../button/SecondaryBtn";
import toast from "react-hot-toast";
import {
  getAllMealOnOrder,
  getCustomerDetail,
  verifyOrderStartDate,
} from "../../../redux/thunks/orderCustomerThunk";
import CalendarInput from "../../form/CalendarInput";
import { saveSubsOrderDraft } from "../../../redux/slices/SubscriptionDraftSlice";
import OnaddressRangeModal from "../../Modals/OnaddressRangeModal";
import RadioCardGroup from "../../button/RadioCardGroup";
import { encryptId } from "../../../utils/urlCrypto";
const formatToTwoDecimal = (value) => {
  return Number(value || 0).toFixed(2);
};

const Addsubscribeform = ({ planType, setPlanType, setTab }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { subscribeDraft } = useSelector((state) => state.subscribeDraft);
  const [errors, setErrors] = useState({});
  const [date, setDate] = useState(subscribeDraft?.order?.date || "");
  const [isDateAvailable, setIsDateAvailable] = useState(true);
  const [mealType, setMealType] = useState(
    subscribeDraft?.order?.mealTiming || "",
  );
  const [deliveryType, setDeliveryType] = useState(
    subscribeDraft?.order?.deliveryType || "",
  );
  const customerId = location?.state?.customerId;
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [allMeals, setAllMeals] = useState([]);
  const [selectedMealId, setSelectedMealId] = useState(
    subscribeDraft?.meal?.id || null,
  );
  const [extraItemsQty, setExtraItemsQty] = useState(() => {
    if (!subscribeDraft) return {};

    const source =
      subscribeDraft?.extraItems?.length > 0 ? subscribeDraft.extraItems : [];
    // console.log("The source is :", source);
    const obj = {};

    source.forEach((item) => {
      const id = item?.extra_item_id; // ✅ ONLY this
      const quantity = item?.qty ?? 0;
      // console.log("the qunatity is :", quantity);
      if (id) {
        obj[id] = quantity || 0;
      }
    });

    return obj;
  });
  const [mealQty, setMealQty] = useState(subscribeDraft?.meal?.qty || 1);
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [spCustomAddId, setSpCustomAddId] = useState(null);
  const [HomeDeliveryStatus, setHomeDeliveryStatus] = useState(false);
  const [selectCustomerFrom, setSelectCustomerFrom] = useState(
    subscribeDraft?.customer?.selectedCustomerId ||
      subscribeDraft?.customer?.id ||
      customerId ||
      "",
  );
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [orderAmount, setOrderAmount] = useState(0);
  const [selectedWeekDays, setSelectedWeekDays] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [getDelCharge, setGetDelCharge] = useState(0);
  const [showOutOfRangeModal, setShowOutOfRangeModal] = useState(false);
  const [allowOutOfRange, setAllowOutOfRange] = useState(false);
  const [selectedLunch, setSelectedLunch] = useState(
    subscribeDraft?.order?.mealTiming === "lunch"
      ? subscribeDraft?.order?.timeSlot || ""
      : "",
  );
  const [selectedDinner, setSelectedDinner] = useState(
    subscribeDraft?.order?.mealTiming === "dinner"
      ? subscribeDraft?.order?.timeSlot || ""
      : "",
  );
  const [notes, setNotes] = useState(subscribeDraft?.orderRemark || "");
  const [lunchSlots, setLunchSlots] = useState([]);
  const [dinnerSlots, setDinnerSlots] = useState([]);
  const [IsDinnerslotsAvailable, setIsDinnerslotsAvailable] = useState(false);
  const [IsLunchSlotsAvailable, setIsLunchSlotsAvailable] = useState(false);
  const [isLunchAvailable, setIsLunchAvailable] = useState(true);
  const [isDinnerAvailable, setIsDinnerAvailable] = useState(true);

  const DAY_LABELS = {
    monday: "M",
    tuesday: "Tu",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
    sunday: "Su",
  };

  // useEffect(() => {
  //   console.log("The customer id got is :", customerId);
  // }, [customerId]);

  // Get customers list to select customer when ordering from order page
  useEffect(() => {
    if (customer.length > 0) return;

    dispatch(getCustomerDetail())
      .unwrap()
      .then((res) => {
        // console.log("The res to check customer details", res.data);
        const getCurrencySymbol = res.data?.currency_symbol;
        setCurrencySymbol(getCurrencySymbol);
        const allCustomersList = res.data?.customers || [];

        setCustomer(allCustomersList);
        setGetDelCharge(res.data?.delivery_charges);
        setHomeDeliveryStatus(res.data?.is_home_delivery);

        const targetCustomerId =
          subscribeDraft?.customer?.selectedCustomerId ||
          subscribeDraft?.customer?.id ||
          customerId ||
          "";

        const customerData = allCustomersList.find(
          (c) => String(c.customer_id) === String(targetCustomerId),
        );

        setSelectCustomerFrom(targetCustomerId || ""); // ✅ ADD THIS
        setSelectedCustomer(customerData || null);

        // 🔥 Restore Address from subscribeDraft if exists
        if (subscribeDraft?.address?.id && customerData?.addresses) {
          const addr = customerData.addresses.find(
            (a) => String(a.address_id) === String(subscribeDraft.address.id),
          );

          setSelectedAddress(addr || null);
          setSpCustomAddId(addr?.address_id || null);
        } else {
          // fallback default address
          const defaultAddress =
            customerData?.addresses?.find((a) => a.is_default) ||
            customerData?.addresses?.[0] ||
            null;

          setSelectedAddress(defaultAddress);
          setSpCustomAddId(defaultAddress?.address_id || null);
        }

        const getdinnerSlots = res.data?.dinner_time_slot.length > 0;
        setIsDinnerslotsAvailable(getdinnerSlots);

        const getLunchSlots = res.data?.lunch_time_slot.length > 0;
        setIsLunchSlotsAvailable(getLunchSlots);

        // 🔥 SET TIME SLOTS FROM API
        const lunchFromApi = res.data?.lunch_time_slot || [];
        const dinnerFromApi = res.data?.dinner_time_slot || [];

        // Convert string array → { value, label }
        const formattedLunch = lunchFromApi.map((slot) => ({
          value: slot,
          label: slot,
        }));

        const formattedDinner = dinnerFromApi.map((slot) => ({
          value: slot,
          label: slot,
        }));

        setLunchSlots(formattedLunch);
        setDinnerSlots(formattedDinner);
      })
      .catch(console.error);
  }, [dispatch, customer.length]);

  useEffect(() => {
    if (allMeals.length > 0) return;

    dispatch(getAllMealOnOrder())
      .unwrap()
      .then((res) => {
        const mealsFromApi = res?.data || [];
        setAllMeals(mealsFromApi);

        if (subscribeDraft?.meal?.id) {
          const mealData = mealsFromApi.find(
            (meal) => meal.meal_id === subscribeDraft.meal.id,
          );

          if (mealData) {
            setSelectedMeal(mealData);
            setSelectedMealId(mealData.meal_id);

            // ✅ FIRST restore planType
            const restoredPlanType =
              subscribeDraft?.order?.planType || "weekly";

            setPlanType(restoredPlanType);

            // ✅ THEN restore selectedPlan using correct planType
            if (subscribeDraft?.meal?.meal_plan_id) {
              const planList =
                restoredPlanType === "monthly"
                  ? mealData.monthly_plans
                  : mealData.weekly_plans;

              const restoredPlan = planList?.find(
                (p) =>
                  String(p.meal_plan_id) ===
                  String(subscribeDraft.meal.meal_plan_id),
              );

              setSelectedPlan(restoredPlan || null);
            }

            if (subscribeDraft?.order?.deliveryDays) {
              setSelectedWeekDays(subscribeDraft.order.deliveryDays);
            }

            setOrderAmount(subscribeDraft?.pricing?.finalAmount || 0);
          }
        }
      })
      .catch((err) => {
        console.error("Meal fetch failed", err);
      });
  }, [dispatch, subscribeDraft]);

  const customerOptions = customer.map((c) => ({
    label: `${c.customer_name} (+${c.country_code} ${c.contact_no})`,
    value: c.customer_id,
  }));

  const mealOptions = allMeals.map((meal) => ({
    label: meal.meal_name, // dropdown me name
    value: meal.meal_id, // actual id
  }));

  const handleMealSelect = (e) => {
    const mealId = Number(e.target.value);
    setSelectedMealId(mealId);

    const mealData = allMeals.find((meal) => meal.meal_id === mealId);
    setSelectedMeal(mealData || null);

    if (mealData) {
      setOrderAmount(mealData.trial_serving_cost);
    }

    setErrors((prev) => ({ ...prev, selectedMeal: "" }));
  };

  const increaseMealQty = () => {
    setMealQty((prev) => prev + 1);
  };

  const decreaseMealQty = () => {
    setMealQty((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const increaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: Math.max((prev[id] || 0) - 1, 0),
    }));
  };

  const toYYYYMMDD = (date) => {
    const d = new Date(date);
    if (isNaN(d)) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (!date || !selectedMealId) return;

    const verifyDate = async () => {
      try {
        const payload = {
          meal_id: selectedMealId,
          meal_plan_type: "trial",
          order_date: toYYYYMMDD(date),
        };

        const dateRes = await dispatch(verifyOrderStartDate(payload)).unwrap();

        if (!dateRes?.success) {
          setIsDateAvailable();
          setMealType("");
          setIsLunchAvailable();
          setIsDinnerAvailable();

          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability: `Meal is not available for ${payload.order_date}`,
          }));
          return;
        }

        // ✅ API SUCCESS
        setIsDateAvailable(true);

        const lunchAvailable = dateRes?.data?.isLunch;

        // console.log("The lunch is :", lunchAvailable);

        const dinnerAvailable = dateRes?.data?.isDinner;

        // console.log("The dinner is :", dinnerAvailable);

        setIsLunchAvailable(lunchAvailable);
        setIsDinnerAvailable(dinnerAvailable);
        if (!lunchAvailable && !dinnerAvailable) {
          setMealType("");
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability:
              "No meal timing available for selected date",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability: "",
          }));
        }

        // 🔥 If currently selected mealType becomes invalid → reset it
        if (mealType === "lunch" && !lunchAvailable) {
          setMealType("");
          setSelectedLunch("");
        }

        if (mealType === "dinner" && !dinnerAvailable) {
          setMealType("");
          setSelectedDinner("");
        }
      } catch (err) {
        setIsDateAvailable(false);
        setMealType("");
        setIsLunchAvailable(false);
        setIsDinnerAvailable(false);

        setErrors((prev) => ({
          ...prev,
          mealTimingAvailability: "Unable to verify selected date",
        }));
      }
    };

    verifyDate();
  }, [selectedMealId, date, dispatch]);

  const calculateOrderAmount = () => {
    const perMealPrice =
      selectedPlan?.perMealPrice ||
      (selectedPlan?.plan_amount && selectedPlan?.order_count
        ? selectedPlan.plan_amount / selectedPlan.order_count
        : 0);

    if (!perMealPrice && subscribeDraft?.meal?.price) {
      return Number(subscribeDraft.meal.price) * (Number(mealQty) || 1);
    }

    let amount = perMealPrice * (Number(mealQty) || 1);

    selectedMeal?.extra_items?.forEach((item) => {
      const qty = Number(extraItemsQty[item.extra_item_id]) || 0;
      amount += (Number(item.amount) || 0) * qty;
    });

    if (deliveryType === "delivery") {
      amount += Number(getDelCharge) || 0;
    }

    return amount;
  };
  useEffect(() => {
    const total = calculateOrderAmount();
    setOrderAmount(total);
  }, [
    selectedMeal,
    selectedPlan,
    mealQty,
    extraItemsQty,
    deliveryType,
    getDelCharge,
  ]);

  const toggleWeekDay = (dayKey) => {
    setSelectedWeekDays((prev) => {
      if (prev.includes(dayKey)) {
        return prev.filter((d) => d !== dayKey);
      }
      return [...prev, dayKey];
    });
  };

  useEffect(() => {
    let addr = null;

    // 1️⃣ If coming back from address page
    if (location.state?.selectedAddress) {
      addr = location.state.selectedAddress;
    }
    // 2️⃣ Else use draft
    else if (subscribeDraft?.address?.id && selectedCustomer?.addresses) {
      addr = selectedCustomer.addresses.find(
        (a) => String(a.address_id) === String(subscribeDraft.address.id),
      );
    }
    // 3️⃣ Fallback default address
    else if (selectedCustomer?.addresses?.length > 0) {
      addr =
        selectedCustomer.addresses.find((a) => a.is_default) ||
        selectedCustomer.addresses[0];
    }

    if (addr) {
      setSelectedAddress(addr);
      setSpCustomAddId(addr.address_id);
    }
  }, [location.state, subscribeDraft, selectedCustomer]);

  useEffect(() => {
    if (planType === "monthly" && selectedWeekDays.length < 2) {
      setErrors((prev) => ({
        ...prev,
        weekDays: "Please select at least 2 delivery days",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        weekDays: "",
      }));
    }
  }, [selectedWeekDays, planType]);
  const validateFields = () => {
    const newErrors = {};

    if (!selectedCustomer && !selectCustomerFrom) {
      newErrors.customer = "Please select customer first";
    }

    if (!selectedMeal) {
      newErrors.selectedMeal = "Please select a meal";
    }

    if (!date) {
      newErrors.date = "Please select order date";
    }

    if (mealType === "lunch" && IsLunchSlotsAvailable) {
      if (!selectedLunch) {
        newErrors.timeSlot = "Please select lunch time slot";
      }
    }

    if (mealType === "dinner" && IsDinnerslotsAvailable) {
      if (!selectedDinner) {
        newErrors.timeSlot = "Please select dinner time slot";
      }
    }

    if (!mealType) {
      newErrors.mealTimingAvailability = "Please select meal timing";
    }

    if (!deliveryType) {
      newErrors.deliveryType = "Please select delivery type";
    }

    if (deliveryType === "delivery") {
      if (!selectedCustomer) {
        newErrors.customer = "Please select customer first";
      }

      if (!selectedAddress) {
        newErrors.address = "Please select delivery address";
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // ✅ true if no error
  };

  const proceedToNextStep = () => {
    const formattedExtraItems =
      selectedMeal.extra_items
        ?.filter(
          (item) => item.extra_item_id && extraItemsQty[item.extra_item_id] > 0,
        )
        .map((item) => ({
          meal_extra_item_id: item.meal_extra_item_id,
          quantity: extraItemsQty[item.extra_item_id],
        })) || [];

    const extrasTotalValue =
      selectedMeal?.extra_items?.reduce((total, item) => {
        const id = item.extra_item_id; // 👈 single consistent key
        const qty = Number(extraItemsQty[id] ?? 0);

        const itemTotal = Number(item.amount ?? 0) * qty;

        return total + itemTotal;
      }, 0) || 0;

    const subscriptionDraftData = {
      // CUSTOMER UI
      currencySymbol: currencySymbol,
      customer: {
        id: customerId,
        selectedCustomerId: selectCustomerFrom,
        name: selectedCustomer?.customer_name,
        phone: `+${selectedCustomer?.country_code} ${selectedCustomer?.contact_no}`,
        initials: getInitials(selectedCustomer?.customer_name),
      },

      // MEAL UI
      meal: {
        id: selectedMealId,
        name: selectedMeal?.meal_name,
        image: selectedMeal?.meal_cover_image,
        price: formatToTwoDecimal(
          selectedPlan?.perMealPrice ||
            selectedPlan?.plan_amount / selectedPlan?.order_count ||
            0,
        ),
        qty: mealQty,
        description: selectedMeal?.meal_description,
        meal_plan_id: selectedPlan?.meal_plan_id,
        subscriptionCost: selectedPlan?.plan_amount,
        totalMeals: selectedPlan?.order_count,
      },

      // EXTRA ITEMS UI
      extra_Item: formattedExtraItems,
      extraItems: selectedMeal.extra_items
        ?.filter((item) => extraItemsQty[item.extra_item_id] > 0)
        .map((item) => ({
          name: item.name,
          extra_item_id: item.extra_item_id,
          qty: extraItemsQty[item.extra_item_id],
          amount: item.amount,
          total: item.amount * extraItemsQty[item.extra_item_id],
          meal_extra_item_id: item.meal_extra_item_id,
        })),

      // ORDER META
      order: {
        date,
        mealTiming: mealType,
        timeSlot:
          mealType === "lunch"
            ? selectedLunch
            : mealType === "dinner"
              ? selectedDinner
              : "",
        deliveryType,
        planType: planType,
        deliveryDays: planType === "monthly" ? selectedWeekDays : [],
      },

      // ADDRESS UI
      address:
        deliveryType === "delivery"
          ? {
              id: spCustomAddId,
              fullAddress: selectedAddress
                ? `${selectedAddress.address_1}, ${selectedAddress.address_2 || ""}`
                : "",
              latitude: selectedAddress?.latitude,
              longitude: selectedAddress?.longitude,
            }
          : null,

      addressId: spCustomAddId,

      // AMOUNT BREAKDOWN
      pricing: {
        mealTotal: formatToTwoDecimal(
          Number(
            selectedPlan?.perMealPrice ||
              selectedPlan?.plan_amount / selectedPlan?.order_count ||
              0,
          ) * (Number(mealQty) || 1),
        ),

        extrasTotal: formatToTwoDecimal(extrasTotalValue),

        deliveryCharge: deliveryType === "delivery" ? Number(getDelCharge) : 0,

        discount: 0,

        finalAmount: formatToTwoDecimal(
          Number(selectedPlan?.perMealPrice || 0) * mealQty +
            extrasTotalValue +
            (deliveryType === "delivery" ? Number(getDelCharge) : 0),
        ),
      },
      orderRemark: notes,
    };
    // console.log("The form data is :", subscriptionDraftData);
    dispatch(saveSubsOrderDraft(subscriptionDraftData));

    setTab(1);
  };

  const handleOnContinue = async () => {
    const isValid = validateFields();

    if (!isValid) {
      return;
    }

    if (
      deliveryType === "delivery" &&
      selectedAddress &&
      selectedAddress.is_on_delivery_distance === 0 &&
      !allowOutOfRange
    ) {
      setShowOutOfRangeModal(true);
      return; // 🚫 stop here
    }

    proceedToNextStep();
  };

  useEffect(() => {
    if (!selectedMeal) return;

    const formattedExtraItems =
      selectedMeal.extra_items
        ?.filter(
          (item) => item.extra_item_id && extraItemsQty[item.extra_item_id] > 0,
        )
        .map((item) => ({
          meal_extra_item_id: item.meal_extra_item_id,
          extra_item_id: item.extra_item_id,
          quantity: extraItemsQty[item.extra_item_id],
        })) || [];

    const extrasTotalValue =
      selectedMeal?.extra_items?.reduce((total, item) => {
        const qty = Number(extraItemsQty[item.extra_item_id]) || 0;
        return total + Number(item.amount || 0) * qty;
      }, 0) || 0;

    const subscriptionDraftData = {
      // CUSTOMER UI
      currencySymbol: currencySymbol,
      customer: {
        id: customerId,
        selectedCustomerId: selectCustomerFrom,
        name: selectedCustomer?.customer_name,
        phone: `+${selectedCustomer?.country_code} ${selectedCustomer?.contact_no}`,
        initials: getInitials(selectedCustomer?.customer_name),
      },

      // MEAL UI
      meal: {
        id: selectedMealId,
        name: selectedMeal?.meal_name,
        image: selectedMeal?.meal_cover_image,
        price: formatToTwoDecimal(
          selectedPlan?.perMealPrice ||
            selectedPlan?.plan_amount / selectedPlan?.order_count ||
            0,
        ),
        qty: mealQty,
        description: selectedMeal?.meal_description,
        meal_plan_id: selectedPlan?.meal_plan_id,
        subscriptionCost: selectedPlan?.plan_amount,
        totalMeals: selectedPlan?.order_count,
      },

      // EXTRA ITEMS UI
      extra_Item: formattedExtraItems,
      extraItems: selectedMeal.extra_items
        ?.filter((item) => extraItemsQty[item.extra_item_id] > 0)
        .map((item) => ({
          name: item.name,
          extra_item_id: item.extra_item_id,
          qty: extraItemsQty[item.extra_item_id],
          amount: item.amount,
          total: item.amount * extraItemsQty[item.extra_item_id],
          meal_extra_item_id: item.meal_extra_item_id,
        })),

      // ORDER META
      order: {
        date,
        mealTiming: mealType,
        timeSlot:
          mealType === "lunch"
            ? selectedLunch
            : mealType === "dinner"
              ? selectedDinner
              : "",
        deliveryType,
        planType: planType,
        deliveryDays: planType === "monthly" ? selectedWeekDays : [],
      },

      // ADDRESS UI
      address:
        deliveryType === "delivery"
          ? {
              id: spCustomAddId,
              fullAddress: selectedAddress
                ? `${selectedAddress.address_1}, ${selectedAddress.address_2 || ""}`
                : "",
              latitude: selectedAddress?.latitude,
              longitude: selectedAddress?.longitude,
            }
          : null,

      addressId: spCustomAddId,

      // AMOUNT BREAKDOWN
      pricing: {
        mealTotal: formatToTwoDecimal(
          Number(
            selectedPlan?.perMealPrice ||
              selectedPlan?.plan_amount / selectedPlan?.order_count ||
              0,
          ) * (Number(mealQty) || 1),
        ),

        extrasTotal: formatToTwoDecimal(extrasTotalValue),

        deliveryCharge: deliveryType === "delivery" ? Number(getDelCharge) : 0,

        discount: 0,

        finalAmount: formatToTwoDecimal(
          Number(selectedPlan?.perMealPrice || 0) * mealQty +
            extrasTotalValue +
            (deliveryType === "delivery" ? Number(getDelCharge) : 0),
        ),
      },
      orderRemark: notes,
    };

    dispatch(saveSubsOrderDraft(subscriptionDraftData));
  }, [
    selectedCustomer,
    selectedMeal,
    selectedMealId,
    mealQty,
    extraItemsQty,
    mealType,
    deliveryType,
    selectedAddress,
    date,
    orderAmount,
    getDelCharge,
    dispatch,
  ]);

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const targetCustomerId = customerId || selectCustomerFrom;

  const hasAddress =
    Array.isArray(selectedCustomer?.addresses) &&
    selectedCustomer.addresses.length > 0;
  return (
    <>
      <div className="flex flex-col justify-center space-y-4">
        {/* <h1>Test</h1> */}
        {/* Select customers */}
        {location?.state?.from === "order" ? (
          <div className="w-full">
            <div>
              <Select
                label="Customer"
                value={selectCustomerFrom}
                onChange={(val) => {
                  setSelectCustomerFrom(val);
                  const cust = customer.find(
                    (c) => String(c.customer_id) === String(val),
                  );

                  setSelectedCustomer(cust || null);

                  // 🔥 Reset delivery & address on customer change
                  setDeliveryType("");
                  setSelectedAddress(null);
                  setSpCustomAddId(null);
                }}
                options={customerOptions}
              />
              {customer.length <= 0 && (
                <p className="text-xs text-red-500 mt-1">
                  No customers found, please add customer first
                </p>
              )}
              {errors.customer && (
                <p className="text-xs text-red-500 mt-1">{errors.customer}</p>
              )}
              <button
                onClick={() => navigate("/add-new-customer")}
                className="text-[#FF6943] mt-4 text-sm font-medium hover:underline cursor-pointer flex items-center justify-end gap-2"
              >
                <span className="border border-[#FF6943] rounded-md flex items-center justify-center w-4 h-4">
                  <Plus size={12} />
                </span>
                Add New Customers
              </button>
            </div>
          </div>
        ) : (
          selectedCustomer && (
            <div className="bg-white p-4 hover:shadow-md duration-300 border border-gray-100 rounded-xl">
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 flex items-center justify-center rounded-xl bg-[#FFEFEB] border border-[#FFCCBF] text-[#FF6943] font-semibold">
                  {getInitials(selectedCustomer.customer_name) || ""}
                </div>
                <div>
                  <h2 className="text-base font-semibold">
                    {selectedCustomer.customer_name || ""}
                  </h2>
                  <p className="text-sm text-gray-500 flex gap-2 justify-start items-center">
                    <FiPhoneCall />+{selectedCustomer.country_code || ""}{" "}
                    {selectedCustomer.contact_no || ""}
                  </p>
                </div>
              </div>
            </div>
          )
        )}

        {/* Select meal */}
        <div className="w-full">
          <div>
            <Select
              label="Select Meal"
              required={true}
              value={selectedMealId}
              onChange={(val) => handleMealSelect({ target: { value: val } })}
              options={mealOptions}
            />
            {errors.selectedMeal && (
              <p className="text-xs text-red-500 mt-1">{errors.selectedMeal}</p>
            )}
          </div>
        </div>

        {/* Users info */}
        {selectedMeal && (
          <div className="mt-4 border border-gray-100 rounded-md p-4">
            <div className="flex items-center justify-between gap-4">
              {/* Left */}
              <div className="flex items-center gap-4">
                <img
                  src={selectedMeal.meal_cover_image}
                  alt={selectedMeal.meal_name}
                  className="w-12 h-12 rounded-md object-cover"
                />

                <div>
                  <h2 className="text-base font-semibold">
                    {selectedMeal.meal_name}
                  </h2>
                  {selectedPlan && (
                    <>
                      <p className="text-[#FF6943] font-bold">
                        {currencySymbol}
                        {Number(
                          selectedPlan?.perMealPrice ||
                            selectedPlan?.plan_amount /
                              selectedPlan?.order_count ||
                            0,
                        ).toFixed(2)}
                      </p>

                      <p className="text-gray-400 text-start text-xs mt-2">
                        {planType === "weekly"
                          ? "Weekly plan single meal price"
                          : "Monthly plan single meal price"}
                      </p>
                    </>
                  )}
                </div>
              </div>

              {/* Right - Quantity */}
              <div className="flex items-center gap-3">
                <button
                  onClick={decreaseMealQty}
                  type="button"
                  className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                >
                  −
                </button>

                <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                  {mealQty}
                </span>

                <button
                  type="button"
                  onClick={increaseMealQty}
                  className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                >
                  +
                </button>
              </div>
            </div>

            <p className="mt-2 text-sm text-gray-500">
              {selectedMeal.meal_description}
            </p>
          </div>
        )}
        {/* Extra items */}
        {selectedMeal?.extra_items?.length > 0 && (
          <div className="mt-2">
            <p>Extra items</p>

            {selectedMeal.extra_items.map((item) => (
              <div
                key={item.extra_item_id}
                className="border border-gray-100 p-4 rounded-md mt-3"
              >
                <div className="flex flex-row sm:justify-between gap-4">
                  {/* Left */}
                  <div className="flex flex-col">
                    <p className="text-sm sm:text-base text-gray-700">
                      {item.name}
                    </p>
                    <p className="mt-1 font-bold text-[#FF6943] text-sm sm:text-base">
                      {currencySymbol} {item.amount}
                    </p>
                  </div>

                  {/* Right */}
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={() => decreaseQty(item.extra_item_id)}
                      className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                    >
                      −
                    </button>

                    <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                      {extraItemsQty[item.extra_item_id] || 0}
                    </span>

                    <button
                      type="button"
                      onClick={() => increaseQty(item.extra_item_id)}
                      className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Plan type */}
        <div>
          <div>
            <p className="text-start text-sm text-gray-700">
              Select plan <span className="text-red-500 ml-1">*</span>
            </p>
            <div className="flex gap-3   mt-4">
              <button
                type="button"
                onClick={() => {
                  setPlanType("weekly");
                  setSelectedPlan(null);
                }}
                className={`rounded-md p-2 w-full ${
                  planType === "weekly"
                    ? "bg-[#FF6943] text-white"
                    : "border border-[#FF6943] text-[#FF6943]"
                }`}
              >
                weekly
              </button>

              <button
                type="button"
                onClick={() => {
                  setPlanType("monthly");
                  setSelectedPlan(null);
                }}
                className={`rounded-md p-2 w-full ${
                  planType === "monthly"
                    ? "bg-[#FF6943] text-white"
                    : "border border-[#FF6943] text-[#FF6943]"
                }`}
              >
                monthly
              </button>
            </div>
          </div>
        </div>

        {/* Cards for selection */}
        {/* <div>{planType === "weekly" ? <WeeklyPlan /> : <Montlyplan />}</div> */}
        {planType === "weekly" ? (
          selectedMeal?.weekly_plans?.length > 0 ? (
            <WeeklyPlan
              symbol={currencySymbol}
              weekly={selectedMeal.weekly_plans}
              selectedPlan={selectedPlan}
              onSelectPlan={setSelectedPlan}
            />
          ) : (
            <div className="border border-gray-300 p-4 w-full rounded-md">
              <p className="text-sm text-gray-500 text-center">
                No Weekly plans available
              </p>
            </div>
          )
        ) : null}

        {planType === "monthly" ? (
          selectedMeal?.monthly_plans?.length > 0 ? (
            <Montlyplan
              symbol={currencySymbol}
              monthly={selectedMeal.monthly_plans}
              selectedPlan={selectedPlan}
              onSelectPlan={setSelectedPlan}
            />
          ) : (
            <div className="border border-gray-300 p-4 w-full rounded-md">
              <p className="text-sm text-gray-500 text-center">
                No Monthly plans available
              </p>
            </div>
          )
        ) : null}

        {/* Calender */}
        <div className="w-full">
          <CalendarInput
            required={true}
            label="Order date"
            variant="trial"
            value={date}
            onlyFuture={true}
            onChange={(val) => {
              setDate(val);
              setIsDateAvailable(true);
              setErrors((prev) => ({
                ...prev,
                date: "",
                mealTimingAvailability: "",
              }));
            }}
          />
          {errors.date && (
            <p className="text-xs text-red-500 mt-1">{errors.date}</p>
          )}
        </div>

        {/* Grid for checkbocx */}

        <div>
          <p className="text-sm text-gray-800 text-start">
            Meal Timing <span className="text-red-500 ml-1">*</span>
          </p>

          <div className="flex gap-3 flex-wrap mt-4">
            <Checkbox
              variant="radio"
              label="Lunch"
              name="mealType"
              disabled={!isDateAvailable || !isLunchAvailable}
              icon={<GoSun />}
              checked={mealType === "lunch"}
              onChange={() => {
                setMealType("lunch");
                setSelectedDinner("");
                setErrors((prev) => ({
                  ...prev,
                  mealTimingAvailability: "",
                }));
              }}
            />

            <Checkbox
              variant="radio"
              label="Dinner"
              name="mealType"
              disabled={!isDateAvailable || !isDinnerAvailable}
              icon={<GoMoon />}
              checked={mealType === "dinner"}
              onChange={() => {
                setMealType("dinner");
                setSelectedLunch("");
                setErrors((prev) => ({
                  ...prev,
                  mealTimingAvailability: "",
                }));
              }}
            />
          </div>

          {errors.mealTimingAvailability && (
            <p className="text-xs text-red-500 mt-2">
              {errors.mealTimingAvailability}
            </p>
          )}
        </div>
        <div className="w-full max-w-md space-y-3 mt-4">
          {/* Lunch Slot */}
          {mealType === "lunch" && IsLunchSlotsAvailable && (
            <>
              <p className="text-sm text-gray-800 text-start">
                Lunch Time Slot <span className="text-red-500 ml-1">*</span>
              </p>

              <RadioCardGroup
                options={lunchSlots}
                name="lunchSlot"
                selectedValue={selectedLunch}
                onChange={(value) => {
                  setSelectedLunch(value);
                  setErrors((prev) => ({
                    ...prev,
                    timeSlot: "",
                  }));
                }}
                variant="lunch"
              />
            </>
          )}

          {/* Dinner Slot */}
          {mealType === "dinner" && IsDinnerslotsAvailable && (
            <>
              <p className="text-sm text-gray-800 text-start">
                Dinner Time Slot <span className="text-red-500 ml-1">*</span>
              </p>

              <RadioCardGroup
                options={dinnerSlots}
                name="dinnerSlot"
                selectedValue={selectedDinner}
                onChange={(value) => {
                  setSelectedDinner(value);
                  setErrors((prev) => ({
                    ...prev,
                    timeSlot: "",
                  }));
                }}
                variant="dinner"
              />
            </>
          )}

          {errors.timeSlot && (
            <p className="text-xs text-red-500 mt-2">{errors.timeSlot}</p>
          )}
        </div>
        {planType === "monthly" &&
          selectedMeal?.availability_data?.length > 0 && (
            <div>
              <p className="text-sm text-gray-700 text-start">Deliver Days</p>

              <div className="flex gap-2 justify-start mt-4 flex-wrap">
                {selectedMeal.availability_data.map((day) => {
                  const isDisabled = !day.isActive;
                  const isSelected = selectedWeekDays.includes(day.key);

                  return (
                    <button
                      key={day.key}
                      type="button"
                      disabled={isDisabled}
                      onClick={() => toggleWeekDay(day.key)}
                      className={`
              w-6 h-6 rounded-md text-[11px] font-medium
              flex items-center justify-center
              transition-all border border-gray-200 text-gray-400  
              ${
                isDisabled
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : isSelected
                    ? "bg-[#FF6943] text-white"
                    : "border border-[#FF6943] text-[#FF6943]"
              }
            `}
                    >
                      {DAY_LABELS[day.key]}
                    </button>
                  );
                })}
              </div>

              {errors.weekDays && (
                <p className="text-xs text-red-500 mt-1">{errors.weekDays}</p>
              )}
            </div>
          )}

        <div>
          <p className="text-sm text-gray-800 text-start">
            Delivery Type <span className="text-red-500 ml-1">*</span>
          </p>
          <div className="flex gap-3 flex-wrap mt-4">
            <div className="flex flex-col">
              <Checkbox
                variant="radio"
                label="Home delivery"
                name="delivery"
                checked={deliveryType === "delivery"}
                disabled={!HomeDeliveryStatus}
                onChange={() => {
                  if (!selectedCustomer) {
                    setErrors((prev) => ({
                      ...prev,
                      customer: "Please select customer first",
                    }));
                    return;
                  }

                  setDeliveryType("delivery");

                  const defaultAddr =
                    selectedCustomer?.addresses?.find((a) => a.is_default) ||
                    selectedCustomer?.addresses?.[0];

                  setSelectedAddress(defaultAddr);
                  setSpCustomAddId(defaultAddr?.address_id);

                  setErrors((prev) => ({
                    ...prev,
                    deliveryType: "",
                    customer: "",
                  }));
                }}
                onDisabledClick={() =>
                  toast.error("Home delivery is not available right now")
                }
              />
            </div>
            <Checkbox
              variant="radio"
              label="Pickup"
              name="pickup"
              checked={deliveryType === "pickup"}
              onChange={(e) => setDeliveryType(e.target.name)}
            />
          </div>
          {deliveryType === "delivery" && (
            <p className="text-xs text-start text-[#FF6943] mt-2">
              Delivery Charges : ${getDelCharge}
            </p>
          )}
          {errors.deliveryType && (
            <p className="text-xs text-red-500 mt-2">{errors.deliveryType}</p>
          )}
        </div>

        {/* Adding new Address */}

        {deliveryType === "delivery" && (
          <>
            {!selectedCustomer ? null : !hasAddress ? (
              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/customer/add-customers-address/${encryptId(targetCustomerId)}`,
                  )
                }
                className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
              >
                <span className="text-lg">＋</span> Add New Address
              </button>
            ) : (
              <InputBase
                type="textarea"
                variant="location"
                onChange={() => {}}
                rows={2}
                readOnly
                onChangeLocation={() =>
                  navigate(`/address/${encryptId(targetCustomerId)}`, {
                    state: { from: "addOrder" },
                  })
                }
                value={
                  selectedAddress
                    ? `${selectedAddress.address_1}${selectedAddress.address_2 ? ", " + selectedAddress.address_2 : ""}`
                    : ""
                }
              />
            )}
          </>
        )}

        <div>
          <InputBase
            label={"Order Remark"}
            placeholder="Enter Order Remark"
            type="textarea"
            rows={2}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div>
          {selectedMeal && (
            <div>
              <p>Per order Amount</p>
              <div className="relative shrink-0 w-full mt-2">
                <span className="absolute inset-y-0 left-0 flex items-center px-3 text-red-500 bg-red-50 border border-r-0 border-red-200 rounded-l-md text-sm font-medium">
                  {currencySymbol}
                </span>

                <input
                  type="text"
                  value={formatToTwoDecimal(orderAmount)}
                  disabled
                  className="
                    w-full
                    pl-10 pr-2 py-2
                    text-start text-sm
                    border border-red-200
                    rounded-md
                    outline-none
                    focus:ring-2 focus:ring-red-200
                    "
                />
              </div>
            </div>
          )}
          <div>
            <div className="mt-4 md:mt-12 flex justify-center items-center md:justify-end">
              <SecondaryBtn btnName="Continue" clickEvent={handleOnContinue} />
            </div>
          </div>
        </div>
      </div>

      {showOutOfRangeModal && (
        <OnaddressRangeModal
          open={showOutOfRangeModal}
          onClose={() => setShowOutOfRangeModal(false)}
          onConfirm={() => {
            setAllowOutOfRange(true);
            proceedToNextStep();
          }}
        />
      )}
    </>
  );
};

export default Addsubscribeform;
